import { useLayoutEffect, useRef } from "react";

import { gsap } from "gsap";

import "./style.scss";
const CarModel = () => {
	const carRef = useRef<HTMLDivElement | null>(null);
	const scrollTriggerRef = useRef<HTMLDivElement | null>(null);
	useLayoutEffect(() => {
		if (typeof window === "undefined") return;

		if (!carRef.current || !scrollTriggerRef.current) return;
		const gsapMatchMedia = gsap.matchMedia();
		let savedSectionEl: HTMLElement | null = null;
		let savedPrevMinHeight: string = "";
		const initScrollTrigger = () => {
			gsapMatchMedia.add(
				{ isMobile: "(max-width: 768px)", isDesktop: "(min-width: 769px)" },
				(context) => {
					const { isMobile } = context.conditions!;
					const sectionEl = scrollTriggerRef.current?.closest(
						".tech-intro-section_1",
					) as HTMLElement | null;
					if (!sectionEl) return;
					savedSectionEl = sectionEl;

					// Plan A: Outer pin (애니 + 대기) & Inner scrub (애니만)
					const animDist = Math.round(window.innerHeight * (isMobile ? 1.2 : 1.7));

					// pinSpacing: false를 사용할 것이므로, 섹션 자체 높이를
					// 애니메이션이 끝나는 지점까지 늘려 스크롤 거리를 확보한다.
					savedPrevMinHeight = sectionEl.style.minHeight;
					sectionEl.style.minHeight = `${window.innerHeight + animDist}px`;

					// Inner animation: 애니 구간만 스크럽
					const tl = gsap.timeline({
						defaults: { ease: "none" },
						scrollTrigger: {
							trigger: sectionEl,
							start: "top top",
							end: `+=${animDist}`,
							pin: sectionEl,
							pinSpacing: false,
							scrub: 1.5,
							endTrigger: ".end-trigger",
							invalidateOnRefresh: true,
						},
					});

					// 1) 차량 등장 (오른쪽 -> 제자리)
					tl.fromTo(
						carRef.current,
						{ xPercent: 50, opacity: 0 },
						{ xPercent: -7, opacity: 1, duration: 3, immediateRender: false },
					);

					// 2) 주행 중 바퀴 회전 (차량 등장과 동시에 시작)
					tl.to(".car-model__wheel", { rotate: -360, duration: 3 }, "<");

					// 3) 1,2번 애니메이션 모두 종료 후 창문 노출
					tl.to(
						[".car-model__front-window", ".car-model__back-window"],
						{ opacity: 1, duration: 3 },
						">",
					);
					tl.to({}, { duration: 0.5 });
				},
			);
		};
		initScrollTrigger();
		return () => {
			// 섹션 높이 원복
			if (savedSectionEl) savedSectionEl.style.minHeight = savedPrevMinHeight;
			gsapMatchMedia.revert();
		};
	}, []);

	return (
		<div className="car-model-container" ref={scrollTriggerRef}>
			<div className="car-model" ref={carRef}>
				<img
					className="car-model__car"
					src="/images/main/car-1/car.webp"
					alt="Car Object"
				/>
				<img
					className="car-model__wheel left"
					src="/images/main/car-1/wheel.webp"
					alt="Wheel Object"
				/>
				<img
					className="car-model__wheel right"
					src="/images/main/car-1/wheel.webp"
					alt="Wheel Object"
				/>
				<img
					className="car-model__front-window"
					src="/images/main/car-1/front-window.png"
					alt="Wheel Object"
				/>
				<img
					className="car-model__back-window"
					src="/images/main/car-1/back-window.png"
					alt="Wheel Object"
				/>
			</div>
		</div>
	);
};

export default CarModel;
